$(function () {

  const sections = document.querySelectorAll("section");
  const navLinks = document.querySelectorAll(".scroll-menu a");
  const scrollMenu = document.querySelector(".scroll-menu");
  const lastSection = document.querySelector("#resources");

  function setActiveLink() {
    let current = "";

    sections.forEach(section => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.clientHeight;

      if (
        window.scrollY >= sectionTop - 120 &&
        window.scrollY < sectionTop + sectionHeight - 120
      ) {
        current = section.getAttribute("id");
      }
    });

    navLinks.forEach(link => {
      link.classList.remove("active");
      if (link.getAttribute("href") === "#" + current) {
        link.classList.add("active");
      }
    });

    // REMOVE STICKY AFTER LAST SECTION
    if (lastSection) {
      const lastTop = lastSection.offsetTop;
      const lastHeight = lastSection.clientHeight;

      if (window.scrollY >= lastTop + lastHeight - 150) {
        scrollMenu.classList.add("remove-sticky");
      } else {
        scrollMenu.classList.remove("remove-sticky");
      }
    }
  }

  // Active link on scroll
  window.addEventListener("scroll", setActiveLink);

  // Menu click with 80px offset & address bar URL vanity anchor updating
  navLinks.forEach(link => {
    link.addEventListener("click", function (e) {
      const href = this.getAttribute("href");
      if (href && href.startsWith("#")) {
        e.preventDefault();

        navLinks.forEach(l => l.classList.remove("active"));
        this.classList.add("active");

        const targetId = href.length > 1 ? href.substring(1) : "";
        const target = targetId ? document.getElementById(targetId) : null;

        if (target) {
          window.scrollTo({
            top: target.offsetTop - 80,
            behavior: "smooth"
          });

          // Updates the browser address bar URL with the vanity anchor slug (e.g. #fees-and-charges)
          // without triggering an abrupt browser page jump.
          if (window.history && window.history.pushState) {
            window.history.pushState(null, "", href);
          }
        }
      }
    });
  });

  // Body sticky class
  $(window).on("scroll resize", function () {

    if (!scrollMenu) return;

    const menuTop = scrollMenu.getBoundingClientRect().top;

    if (menuTop <= 65) {
      $("body").addClass("scroll-menu-sticky");
    } else {
      $("body").removeClass("scroll-menu-sticky");
    }

  });

  // Initial state
  setActiveLink();
  $(window).trigger("scroll");

});


$(window).on("scroll", function () {
  if ($(this).scrollTop() >= 400) {
    $(".header-grid").addClass("header-blur");
  } else {
    $(".header-grid").removeClass("header-blur");
  }
});